import styled from '@emotion/styled';

import { colors } from '../../../styles/colors';
import { MediaBP as MQ } from '../../../styles/mediaQuery';
import { skeletonLoading } from '../../../styles/styles';

export const Container = styled.div`
  width: 100%;
  height: 200px;
  padding: 0px 16px;
  ${MQ.MediaSm} {
    padding: 0px;
  }
`;
export const Header = styled.div`
  &::before {
    content: '';
    border-radius: 6px;
    background-color: ${colors.TemplateLoaderAccent};
    width: 280px;
    height: 32px;
    display: block;
    margin-bottom: 13px;
    margin-top: 24px;
    ${MQ.MediaLg} {
      width: 320px;
      height: 48px;
    }
  }
`;

export const Body = styled.div`
  width: 100%;
  &::before {
    content: '';
    border-radius: 6px;
    background-color: ${colors.TemplateLoaderTrayBgDesktop};
    width: 100%;
    height: 320px;
    display: block;
    margin-bottom: 13px;
    margin-top: 24px;
    ${MQ.MediaLg} {
      height: 320px;
    }
  }
  position: relative;
  ${skeletonLoading};
`;
